/**
 * Decides once, at load, whether this device gets the 3D experience.
 * Never re-evaluated — resizing must never tear down the WebGL scene.
 *
 * A finger cannot hover; a mouse can. Coarse pointer + no hover identifies
 * phones and tablets in any orientation, while a touchscreen laptop still
 * qualifies as desktop because its mouse can hover.
 */
const decide = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return true
  const isTouchDevice =
    window.matchMedia('(pointer: coarse)').matches &&
    window.matchMedia('(hover: none)').matches
  return !isTouchDevice
}

export const IS_DESKTOP_EXPERIENCE = decide()

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute(
    'data-experience',
    IS_DESKTOP_EXPERIENCE ? 'desktop' : 'flat',
  )
}
